import React from 'react';
import { Box, Paper, Typography, Divider, Grid, Avatar } from '@mui/material';

const AverageGradeCard = ({ data = [] }) => {
  const normalizeRatings = (data: any) => {
    if (Array.isArray(data)) return data;

    if (typeof data === 'object' && data !== null) {
      return Object.entries(data).map(([rating, count]) => ({
        rating,
        count,
      }));
    }

    return [];
  };

  const calculateMetrics = (listData: any) => {
    const mapping = { S: 1, A: 1, B: 1, C: 1, D: 1, E: 1.6 };

    const dataArray = normalizeRatings(listData);

    const validRatings = dataArray.filter((item) => item.rating !== 'Not Rated' && item.rating !== 'To be done');

    let totalWeightedScore = 0;
    let totalCount = 0;

    validRatings.forEach((item) => {
      const weight = mapping[item.rating] ?? 1;
      totalWeightedScore += weight * item.count;
      totalCount += item.count;
    });

    const averageRating = totalCount > 0 ? totalWeightedScore / totalCount : 0;

    let averageGrade = 'E';
    if (averageRating <= 1.05) averageGrade = 'A';
    else if (averageRating <= 1.2) averageGrade = 'B';
    else if (averageRating <= 1.4) averageGrade = 'C';
    else if (averageRating <= 1.55) averageGrade = 'D';

    // Cap highest grade to B
    // if (averageGrade === 'A') averageGrade = 'B';

    return {
      averageGrade,
      averageRating: Number(averageRating.toFixed(3)),
      objectiveRating: 4.3,
    };
  };

  const { averageGrade, averageRating, objectiveRating } = calculateMetrics(data);

  return (
    <Paper elevation={6} sx={{ p: 3, borderRadius: 4, height: '100%', overflow: 'hidden', bgcolor: '#f9fafb' }}>
      <Box display="flex" flexDirection="column" alignItems="center" mb={2}>
        <Avatar
          sx={{
            bgcolor: '#1976d2',
            width: 72,
            height: 72,
            mb: 1,
            fontSize: 40,
            fontWeight: 'bold',
          }}
        >
          {averageGrade}
        </Avatar>
        <Typography variant="subtitle1" color="text.secondary">
          Average grade
        </Typography>
      </Box>

      <Divider sx={{ my: 2, mt: 3 }} />

      <Grid container spacing={2} justifyContent="center" sx={{ mt: 1 }}>
        <Grid item xs={6} textAlign="center">
          <Typography variant="h6" color="primary">
            {averageRating}
          </Typography>
          <Typography variant="caption" color="text.secondary">
            Average rating
          </Typography>
        </Grid>
        <Grid item xs={6} textAlign="center">
          <Typography variant="h6" color="primary">
            {objectiveRating}
          </Typography>
          <Typography variant="caption" color="text.secondary">
            Objective rating
          </Typography>
        </Grid>
      </Grid>
    </Paper>
  );
};

export default AverageGradeCard;
